module.exports = __webpack_public_path__ + "img/bd(2).828e25ac.webp";